<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <h6>Listado de Notas</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Responsable" dense v-model="filtroresp">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Empresa" dense v-model="filtroempresa">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Referencia" dense v-model="filtroreferencia">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="2">
                            <v-text-field label="Filtro por Factibilidad" dense v-model="filtrofact">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row align="center" justify="space-around">
                        <v-btn tile color="success" @click="cargarListado()">
                            <v-icon left> mdi-magnify </v-icon>
                            Buscar
                        </v-btn>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="500" :footer-props="{ itemsPerPageText: 'Factibilidades por página', }"
                :loading="loadtable" loading-text="Cargando... Espere por favor"
                no-data-text="No hay datos disponibles">
                <template v-slot:item.actions="{ item }">
                    <!-- <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }"> -->
                    <v-icon small color="blue" class="mr-2" @click.stop="cargaradjunto(item)">
                        mdi-file
                    </v-icon>
                    <!-- </template>
</v-tooltip> -->
                </template>
            </v-data-table>
            <Adjunto :visible="showAdjunto" :codgral="editedItem.codgral" @close="showAdjunto = false">
            </Adjunto>
        </v-app>
    </div>
</template>

<script>
import axios from "../../../axios-auth.js";
import Adjunto from "../Cotizacion/Notaadjunto.vue"

export default {
    components: { Adjunto },
    data: (vm) => ({
        editedItem: {},
        editedIndex: -1,
        filtroempresa: "",
        filtroresp: "",
        filtroperiodo: "",
        filtroreferencia: "",
        filtrofact: "",
        listado: [],
        loadtable: false,
        showAdjunto: false,
        headers: [
            {
                text: "N° Nota",
                align: "start",
                sortable: false,
                value: "codgral",
            },
            { text: "Cliente", value: "empresa", sortable: false },
            { text: "Referencia", value: "referencia", sortable: false },
            { text: "Fecha", value: "fecha", sortable: false },
            { text: "Responsable", value: "responsable", sortable: false },
            { text: "Factibilidad", value: "fact", sortable: false },
            { text: "Adjunto", value: "actions", sortable: false },

        ],
    }),
    computed: {
        show: {
            get() {
                //this.cargarLegajo();

                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        cargaradjunto(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showAdjunto = true;
        },

        cargarListado() {
            this.loadtable = true;
            const anio = this.filtroperiodo.trimRight(2);
            const resp = this.filtroresp;
            const empresa = this.filtroempresa;
            const referencia = this.filtroreferencia;
            const fact = this.filtrofact;

            let self = this;
            axios
                .get("/Comercial/ListadoNotas?", {
                    params: {
                        anio: anio,
                        resp: resp,
                        empresa: empresa,
                        referencia: referencia,
                        fact: fact,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.loadtable = false;
                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },
    },
};
</script>